<template>
  <div>
    <!-- header -->
    <head-menu></head-menu>

    <!-- banner -->
    <div class="page-head">
      <img src="@/common/imgs/contact.jpg" alt="">
    </div>

    <!-- content -->
    <div class="news-content">
      <div class="news-left">
        <dl>
          <dt>
            <h3>联系我们</h3>
            <p>Contact Us</p>
          </dt>
          <dd class="w50">
            <router-link to="ShenZhen"><span>深圳总部</span><i class="el-icon-arrow-right"></i></router-link>
          </dd>
          <dd class="w50">
            <router-link to="ShenShan" class="active"><span>深汕合作区</span><i class="el-icon-arrow-right"></i></router-link>
          </dd>
        </dl>
      </div>

      <div class="news-right">
        <div class="news-bread">
          <h2>联系我们</h2>/<i>深汕合作区</i>
        </div>
        <div class="txt-descrip">
          <h3>深汕华剑股份高新产业研制厂区</h3>
          <p>地址：广东省汕尾市海丰县深汕特别合作区</p>
          <p>邮编：518000</p>
          <p>电话：0755-8321 1333</p>
          <p>传真：0755-8325 6860</p>
          <p>邮箱：hj009@szhuajian.com</p>
          <div class="map">
            <iframe width='560' height='440' frameborder='0' scrolling='no' marginheight='0' marginwidth='0' src='https://surl.amap.com/zsF0OI1gvY'></iframe>
          </div>
        </div>
      </div>
    </div>

    <!-- footer -->
    <foot-link></foot-link>
     <!-- 回到顶部 -->
    <el-backtop></el-backtop>
    <router-view></router-view>
  </div>
</template>

<script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'
  export default {
    name: 'ShenShan',
    data() {
      return {}
    },
    components: {
      'head-menu': Header,
      'foot-link': Footer
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ShenShan.vue